import Vue from 'vue'

const state = {
  incomplete: [],
  confirmation: [],
  confirmed: [],
  completed: [],
  creditcardCompanies: [],
  journals: []
}

const getters = {
  allCreditcardslips (state) {
    let receipts = [...state.incomplete, ...state.confirmation, ...state.confirmed, ...state.completed]
    return receipts
  },
  creditcardslipsJournals: (state) => state.journals,
  incompleteCreditcardslips: (state) => state.incomplete,
  confirmationCreditcardslips: (state) => state.confirmation,
  confirmedCreditcardslips: (state) => state.confirmed,
  completedCreditcardslips: (state) => state.completed,
  creditcardCompanies: (state) => state.creditcardCompanies
}

const actions = {
  async getAllCreditcardslips ({dispatch}) {
    await dispatch('getIncompleteCreditcardslips')
    await dispatch('getConfirmationCreditcardslips')
    await dispatch('getConfirmedCreditcardslips')
  },
  async getCreditcardslipsJournals ({commit}) {
    const {body} = await Vue.http.get('/creditcardslips/journals')
    commit('setCreditcardslipsJournals', body.data)
  },
  async getIncompleteCreditcardslips ({commit}) {
    const {body} = await Vue.http.get('/creditcardslips/incomplete')
    commit('setIncompleteCreditcardslip', body.data)
  },
  async getCreditcardCompanies ({commit}) {
    const {body} = await Vue.http.get('/creditcard/companies')
    commit('setCreditcardCompanies', body.data)
  },
  async getConfirmationCreditcardslips ({commit}) {
    const {body} = await Vue.http.get('/creditcardslips/confirmation')
    commit('setConfirmationCreditcardslip', body.data)
  },
  async getConfirmedCreditcardslips ({commit}) {
    const {body} = await Vue.http.get('/creditcardslips/confirmed')
    commit('setConfirmedCreditcardslip', body.data)
  },
  async getCompletedCreditcardslips ({commit}) {
    const {body} = await Vue.http.get('/creditcardslips/completed')
    commit('setCompletedCreditcardslip', body.data)
  },
  async saveCreditcardslip ({dispatch}, slip) {
    await Vue.http.post('/creditcardslip/confirmation', slip)
    await dispatch('getConfirmationCreditcardslips')
  },
  async setCreditcardslipState ({dispatch}, {id, state}) {
    await Vue.http.post('/change/state/creditcardslip', {
      state,
      id
    })
  }
}

const mutations = {
  setIncompleteCreditcardslip (state, receipts) {
    state.incomplete = receipts
  },
  setConfirmationCreditcardslip (state, receipts) {
    state.confirmation = receipts
  },
  setConfirmedCreditcardslip (state, receipts) {
    state.confirmed = receipts
  },
  setCompletedCreditcardslip (state, receipts) {
    state.completed = receipts
  },
  setCreditcardCompanies (state, companies) {
    state.creditcardCompanies = companies
  },
  setCreditcardslipsJournals (state, journals) {
    state.journals = journals
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/creditcardslips.js